import React from "react";
import TanvirLogo from "../../img/logo/tanvirLogo.png";
import Resume from "../../file/Md Tanvir Alam-Resume.pdf";
const Header = () => {
  return (
    <div>
      <div class="navbar bg-transparent  max-w-[1100px] mx-auto">
        <div class="navbar ">
          <div class="dropdown text-xl font-bold">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabindex="0"
              class="menu text-xl menu-compact dropdown-content mt-3 p-2 shadow    rounded-box w-52"
            >
              <li>
                <a href="#about">About Me</a>
              </li>

              <li>
                <a href="#project">My Projects</a>
              </li>
              <li>
                <a href="#blog">Blogs</a>
              </li>

              <li>
                <a href="#contact">Contact Me</a>
              </li>
              <li className="p-0">
                <a href={Resume} download={"Tanvir Alam Resume"}>
                  <button
                    className="px-4
                  
                   rounded bg-primary py-2 text-xl text-white flex"
                  >
                    Download Resume
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      />
                    </svg>
                  </button>
                </a>
              </li>
            </ul>
          </div>
          <a class="btn btn-ghost normal-case text-xl">
            <img src={TanvirLogo} alt="TanvirLogo" className="h-12" />
          </a>
        </div>
        <div class="navbar-center hidden lg:flex">
          <ul class="menu text-xl menu-horizontal p-0  ">
            <li>
              <a href="#about">About Me</a>
            </li>
            <li>
              <a href="#project">My Projects</a>
            </li>
            <li>
              <a href="#blog">Blogs</a>
            </li>
            <li>
              <a href="#contact">Contact Me</a>
            </li>
            <li className="p-0">
              <a href={Resume} download={"Tanvir Alam Resume"}>
                <button className="px-4 download-resume rounded bg-primary py-2 text-xl text-white flex">
                  Download Resume
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 ml-2 download-icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
